/**
 * MuiRadio
 *
 *
 * API:
 *
 * - inherits [MuiRadio API](https://mui.com/material-ui/api/radio/)
 *
 * Styles:
 *
 * - [Proto](https://bhdgwebdesignsa.z22.web.core.windows.net/atoms.html#form-fields-controls--radio-button)
 */

const MuiRadio = {
  defaultProps: {
    color: 'secondary',
    disableRipple: true,
    disableFocusRipple: true
  },
  styleOverrides: {
    root: ({
      theme
    }) => ({
      '&:hover': {
        color: theme.palette.secondary[900],
        background: 'none'
      },
      '&.Mui-checked:focus-within > span': {
        outline: `2px solid ${theme.palette.secondary[700]}`,
        borderRadius: '50%'
      }
    })
  }
};
export default MuiRadio;